import { render, staticRenderFns } from "./Innovate.vue?vue&type=template&id=8f830a7c&scoped=true&"
import script from "./Innovate.vue?vue&type=script&lang=js&"
export * from "./Innovate.vue?vue&type=script&lang=js&"
import style0 from "./Innovate.vue?vue&type=style&index=0&id=8f830a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f830a7c",
  null
  
)

export default component.exports